import { render, staticRenderFns } from "./PelatihanReportResultPosttest.vue?vue&type=template&id=41828218"
import script from "./PelatihanReportResultPosttest.vue?vue&type=script&lang=js"
export * from "./PelatihanReportResultPosttest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports